import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import isMobile from 'ismobilejs'
import cx from 'classnames'
import { Div, H1, P, Input, Button, Icon } from '@drifthq/tide-core'

import { shuffle } from 'utils'
import { isExtensionInstalled } from 'utils/extension'

import { track, page } from 'utils/trackingUtils'

import './style.css'

const surveyOptions = [
  {
    isSelected: false,
    label: `📊 Share team-wide updates`
  },
  {
    isSelected: false,
    label: `✉️ Record videos for marketing purposes`
  },
  {
    isSelected: false,
    label: `💸 Send videos to prospects or leads`
  },
  {
    isSelected: false,
    label: `✏️ Show people how to do something`
  },
  {
    isSelected: false,
    label: `📚 Show my work to my peers or managers`
  }
]

const otherOption = {
  isSelected: false,
  label: `📹 Other:`,
  textInput: ''
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
  }, dispatch),
})
class VideoSurveyStep extends React.Component {
  constructor(props) {
    super(props)
    
    const shuffledSurveyOptions = shuffle(surveyOptions)
    shuffledSurveyOptions.push(otherOption)
    
    this.state = {
      surveyOptions: shuffledSurveyOptions,
      freeTextInput: '',
      hasExtension: false
    }
  }

  componentDidMount = () => {
    page('Video Onboarding Survey')
  }

  async componentWillMount() {
    const hasExtension = await isExtensionInstalled()
    this.setState({ hasExtension: hasExtension })
  }

  toggleOption = (index) => {
    const newOptions = this.state.surveyOptions
    const currentValue = this.state.surveyOptions[index].isSelected 
    newOptions[index].isSelected = !currentValue

    this.setState({ surveyOptions: newOptions })
  }

  onTextInputChange = (event) => {
    const value = event.target ? event.target.value : ''

    this.setState({ freeTextInput: value })
  }

  submitSurvey = (selectedOptions) => {
    const selectionList = selectedOptions.map(({ label }) => label.slice(3))
    track('Video Onboarding Survey Submitted', { selectedOptions: selectionList, freeResponse: this.state.freeTextInput })

    if (isMobile.any) {
      this.props.actions.push('/video/success')
    } else if (this.state.hasExtension) {
      this.props.actions.push('/video/landing')
    } else {
      this.props.actions.push('/video/extension')
    }
  }

  render() {
    const { surveyOptions, freeTextInput, hasExtension } = this.state
    const selectedOptions = surveyOptions.filter(({ isSelected }) => isSelected)

    return (
      <Div className="video-card-container">
        <Icon className="video-signup-drift-logo" name="drift-logo-round" />
        <H1>How can Drift Video help you?</H1>
        <P>Let us know what you want to use Drift Video for and we&rsquo;ll get you set up for success. Choose everything that applies:</P>
        <Div className="video-survey-options-container">
          {surveyOptions.map((option, i) => {
            let optionLabel = option.label
            if (option.hasOwnProperty('textInput')) {
              optionLabel = (
                <span className="video-survey-free-text-input" key={`video-survey-option-${i}`}>
                  {option.label}&nbsp;
                  <Input 
                    placeholder="ex. Just to record my screen" 
                    onChange={this.onTextInputChange}
                    value={freeTextInput} />
                </span>
              )
            }
            return (
              <Div onClick={() => this.toggleOption(i)} key={`video-survey-option-${i}`}>
                <Input 
                  className={cx('video-survey-option', { 'selected' : option.isSelected })} 
                  type="checkbox" 
                  label={optionLabel}
                  checked={option.isSelected}
                  key={`video-survey-option-${i}`}
                  />
              </Div>
            )
          })}
        </Div>
        <Button 
          className="video-survey-button" 
          type="primary"
          size="large"
          disabled={selectedOptions.length === 0}
          onClick={() => this.submitSurvey(selectedOptions)}>{hasExtension ? 'Take me to my account!' : 'Continue'}</Button>
      </Div>
    )
  }
}

export default connect(null, mapDispatchToProps)(VideoSurveyStep)



// WEBPACK FOOTER //
// ./src/layouts/VideoSurveyStep/index.js